const mainMenu = () => {
    document.addEventListener("DOMContentLoaded", function() {
        let menuItems = document.querySelectorAll('.menu-item-has-children');

        menuItems.forEach((li) => {
            // Create mobile-expand div
            let div = document.createElement('div');
            div.className = 'mobile-expand';
            div.innerHTML = '<i class="fa-solid fa-chevron-down"></i>';

            // Append to the li
            li.appendChild(div);

            // Add click event to mobile-expand div
            div.addEventListener('click', function(event) {
                event.stopPropagation();

                let submenu = li.querySelector('.sub-menu');
                if (submenu) {
                    if (parseInt(window.getComputedStyle(submenu).height) === 0) {
                        submenu.style.height = submenu.scrollHeight + "px"; // Adjust to natural content height
                    } else {
                        submenu.style.height = "0px";
                    }
                }
            });
        });
    });
}

mainMenu();